import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import './CaseDetailsTool.scss';
import { format } from 'date-fns';

export default function AdditionalTicketInfo(props) {


    const details = props.selectedCaseDetails;
    return (
        <Container>
            {details !== null &&
                <React.Fragment>
                    <div>
                        <div id="account-info-header" className="quote-title">Account Information</div>
                        <Row>
                            <Col md={4}>
                              <p id="br-fa-label" className="stat-title">BR-FA or BR-JPN #</p>
                              <p id="br-fa" className="stat-text">{details.faOfficeNumber && details.faNumber ? (details.faOfficeNumber + '-' + details.faNumber) : 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="br-fa-name-label" className="stat-title">BR-FA or BR-JPN Name</p>
                              <p id="br-fa-name" className="stat-text">{details.faFirstName || details.faLastName ? ((details.faFirstName || '') + (details.faFirstName && details.faLastName && ' ') + (details.faLastName || '')) : 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="account-label" className="stat-title">Account #</p>
                              <p id="account" className="stat-text">{details.clientBranchNumber && details.clientAccountNumber ? (details.clientBranchNumber + '-' + details.clientAccountNumber) : details.clientAccountNumber ? details.clientAccountNumber : 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="account-state-label" className="stat-title">Account legal state</p>
                              <p id="account-state" className="stat-text">{details.accountLegalState || 'N/A'}</p>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <div id="application-info-header" className="quote-title">Application Information</div>
                        <Row>
                            <Col md={4}>
                              <p id="application-state-label" className="stat-title">Application State</p>
                              <p id="application-state" className="stat-text">{details.applicationState || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="solicitation-state-label" className="stat-title">Solicitation State</p>
                              <p id="solicitation-state" className="stat-text">{details.solicitationState || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="delivery-state-label" className="stat-title">Delivery State</p>
                              <p id="delivery-state" className="stat-text">{details.deliveryState || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="application-date-label" className="stat-title">Application Date</p>
                              <p id="application-date" className="stat-text">{details.applicationDate ? format(new Date(details.applicationDate), 'MM-dd-yyyy') : 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="solicitation-date-label" className="stat-title">Solicitation Date</p>
                              <p id="solicitation-date" className="stat-text">{details.solicitationDate ? format(new Date(details.solicitationDate), 'MM-dd-yyyy') : 'N/A'}</p>
                            </Col>
                        </Row>
                    </div>

                </React.Fragment>}
        </Container>
    )
}


// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/AdditionalTicketInfo.js